/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const EvaluationType = {
    AbsoluteValue: 'AbsoluteValue',
    AbsoluteDifference: 'AbsoluteDifference',
    RelativeDifference: 'RelativeDifference',
    Ratio: 'Ratio'
} as const;
export type EvaluationType = typeof EvaluationType[keyof typeof EvaluationType];


export function EvaluationTypeFromJSON(json: any): EvaluationType {
    return EvaluationTypeFromJSONTyped(json, false);
}

export function EvaluationTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): EvaluationType {
    return json as EvaluationType;
}

export function EvaluationTypeToJSON(value?: EvaluationType | null): any {
    return value as any;
}

/**
 * Check if a given object implements the EvaluationType interface.
 */
 export function instanceOfEvaluationType(value: any): value is EvaluationType {
    return Object.values(EvaluationType).includes(value)
}

